module.exports = __webpack_public_path__ + "static/media/Studio_Ghibli.7feca406.png";